import type { CSSProperties } from 'react';

interface CalendarBusyOverlayProps {
  style: CSSProperties;
}

export function CalendarBusyOverlay({ style }: CalendarBusyOverlayProps) {
  return (
    <div
      style={style}
      className="pointer-events-none absolute z-10 rounded-md border border-muted-foreground/40 bg-muted-foreground/25"
      aria-label="Busy"
      title="Busy"
    />
  );
}
